export enum Color {
  Default,
  Yellow,
  Green,
}
